import { render } from "./EditFinanciadores.vue?vue&type=template&id=f480579a&scoped=true"
import script from "./EditFinanciadores.vue?vue&type=script&lang=js"
export * from "./EditFinanciadores.vue?vue&type=script&lang=js"

import "./EditFinanciadores.vue?vue&type=style&index=0&id=f480579a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f480579a"]])

export default __exports__